"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlumTreeRpcClient = exports.NodeInfoRpcClient = exports.TemporaryConnectionRpcClient = exports.NeighborUpdateRpcClient = exports.HandshakeRpcClient = exports.ProxyConnectionRpcClient = exports.ContentDeliveryRpcClient = void 0;
// @generated by protobuf-ts 2.9.6 with parameter server_generic,generate_dependencies,long_type_number
// @generated from protobuf file "packages/trackerless-network/protos/NetworkRpc.proto" (syntax proto3)
// tslint:disable
const NetworkRpc_1 = require("./NetworkRpc");
const NetworkRpc_2 = require("./NetworkRpc");
const NetworkRpc_3 = require("./NetworkRpc");
const NetworkRpc_4 = require("./NetworkRpc");
const NetworkRpc_5 = require("./NetworkRpc");
const NetworkRpc_6 = require("./NetworkRpc");
const NetworkRpc_7 = require("./NetworkRpc");
const runtime_rpc_1 = require("@protobuf-ts/runtime-rpc");
/**
 * @generated from protobuf service ContentDeliveryRpc
 */
class ContentDeliveryRpcClient {
    _transport;
    typeName = NetworkRpc_7.ContentDeliveryRpc.typeName;
    methods = NetworkRpc_7.ContentDeliveryRpc.methods;
    options = NetworkRpc_7.ContentDeliveryRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: sendStreamMessage(StreamMessage) returns (google.protobuf.Empty);
     */
    sendStreamMessage(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: leaveStreamPartNotice(LeaveStreamPartNotice) returns (google.protobuf.Empty);
     */
    leaveStreamPartNotice(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.ContentDeliveryRpcClient = ContentDeliveryRpcClient;
/**
 * @generated from protobuf service ProxyConnectionRpc
 */
class ProxyConnectionRpcClient {
    _transport;
    typeName = NetworkRpc_6.ProxyConnectionRpc.typeName;
    methods = NetworkRpc_6.ProxyConnectionRpc.methods;
    options = NetworkRpc_6.ProxyConnectionRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: requestConnection(ProxyConnectionRequest) returns (ProxyConnectionResponse);
     */
    requestConnection(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.ProxyConnectionRpcClient = ProxyConnectionRpcClient;
/**
 * @generated from protobuf service HandshakeRpc
 */
class HandshakeRpcClient {
    _transport;
    typeName = NetworkRpc_5.HandshakeRpc.typeName;
    methods = NetworkRpc_5.HandshakeRpc.methods;
    options = NetworkRpc_5.HandshakeRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: handshake(StreamPartHandshakeRequest) returns (StreamPartHandshakeResponse);
     */
    handshake(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: interleaveRequest(InterleaveRequest) returns (InterleaveResponse);
     */
    interleaveRequest(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.HandshakeRpcClient = HandshakeRpcClient;
/**
 * @generated from protobuf service NeighborUpdateRpc
 */
class NeighborUpdateRpcClient {
    _transport;
    typeName = NetworkRpc_4.NeighborUpdateRpc.typeName;
    methods = NetworkRpc_4.NeighborUpdateRpc.methods;
    options = NetworkRpc_4.NeighborUpdateRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: neighborUpdate(NeighborUpdate) returns (NeighborUpdate);
     */
    neighborUpdate(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.NeighborUpdateRpcClient = NeighborUpdateRpcClient;
/**
 * @generated from protobuf service TemporaryConnectionRpc
 */
class TemporaryConnectionRpcClient {
    _transport;
    typeName = NetworkRpc_3.TemporaryConnectionRpc.typeName;
    methods = NetworkRpc_3.TemporaryConnectionRpc.methods;
    options = NetworkRpc_3.TemporaryConnectionRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: openConnection(TemporaryConnectionRequest) returns (TemporaryConnectionResponse);
     */
    openConnection(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: closeConnection(CloseTemporaryConnection) returns (google.protobuf.Empty);
     */
    closeConnection(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.TemporaryConnectionRpcClient = TemporaryConnectionRpcClient;
/**
 * @generated from protobuf service NodeInfoRpc
 */
class NodeInfoRpcClient {
    _transport;
    typeName = NetworkRpc_2.NodeInfoRpc.typeName;
    methods = NetworkRpc_2.NodeInfoRpc.methods;
    options = NetworkRpc_2.NodeInfoRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: getInfo(NodeInfoRequest) returns (NodeInfoResponse);
     */
    getInfo(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.NodeInfoRpcClient = NodeInfoRpcClient;
/**
 * @generated from protobuf service PlumTreeRpc
 */
class PlumTreeRpcClient {
    _transport;
    typeName = NetworkRpc_1.PlumTreeRpc.typeName;
    methods = NetworkRpc_1.PlumTreeRpc.methods;
    options = NetworkRpc_1.PlumTreeRpc.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: pauseNeighbor(PauseNeighborRequest) returns (google.protobuf.Empty);
     */
    pauseNeighbor(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: resumeNeighbor(ResumeNeighborRequest) returns (google.protobuf.Empty);
     */
    resumeNeighbor(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: sendMetadata(MessageID) returns (google.protobuf.Empty);
     */
    sendMetadata(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return (0, runtime_rpc_1.stackIntercept)("unary", this._transport, method, opt, input);
    }
}
exports.PlumTreeRpcClient = PlumTreeRpcClient;
//# sourceMappingURL=NetworkRpc.client.js.map